export const transportationData = {
  themeColor: "#DA291C",

  breadcrumbs: [
    {
      text: "HOME",
      url: "/"
    },
    {
      text: "FOR PROS",
      url: null
    },
    {
      text: "INDUSTRIAL SOLUTIONS",
      url: "/industrial-page-new"
    },
    {
      text: "TRANSPORTATION",
      url: null
    }
  ],

  heroCTAs: {
    topButton: {
      text: "REQUEST SAMPLES",
      url: "/industrial/samplesrequest/"
    },
    mainButtons: [
      {
        text: "ASK A TECHNICAL SPECIALIST",
        url: "/industrial/technicalspecialist/",
        variant: "outline"
      },
      {
        text: "REQUEST A SITE ASSESSMENT",
        url: "#site-assessment-form",
        variant: "red"
      }
    ]
  },

  components: [ 
    {
      component: "cardDeck",
      variant: "vertical",
      id: "product-lines",
      eyebrow: "you know the wd-40® brand name —",
      title: "but do you know what it can do for your transportation operation?",
      body: "From rail yards to repair bays, road crews to terminals, WD-40 Specialist® products are trusted to keep critical systems moving. Our high-performance formulas help prevent corrosion, reduce equipment wear, and make maintenance faster—so your fleet, machinery, and infrastructure stay in motion, mile after mile.",
      cards: [
        {  
          id: "clean-degrease",
          image: "/img/industrial-page/new/transportation/Inustrial Solutions - Degreaser Image 2.png",
          title: "CLEANERS & DEGREASERS",
          description: "Remove grease, grime, and contaminants fast",
          linkUrl: "/products/?functionality=clean-degrease"
        },
        {
          id: "lube-penetrants",
          image: "/img/industrial-page/new/transportation/Transportation-Penetrant-Image 1.png",
          title: "LUBRICANTS & PENETRANTS",
          description: "Free stuck parts and reduce friction",
          linkUrl: "/products/?functionality=lubricates%2Cpenetrate-loosen"
        },
        {
          id: "rust-solutions",
          image: "/img/industrial-page/new/transportation/Transportation-RustRemoverSoak-Imagejpg 1.png",
          title: "Rust Solutions",
          description: "Stop rust and protect metal surfaces",
          linkUrl: "/products/?functionality=removes%2Clubricates%2Crestores%2Cprotects%2Cpenetrate-loosen%2Cclean-degrease"
        }
      ],
      ctaText: "BROWSE ALL INDUSTRIAL PRODUCTS",
      ctaUrl: "/products/?category=specialist"
    },
    
    {
      component: "cardDeck",
      variant: "icons",
      id: "facility-applications",
      title: "FACILITY APPLICATIONS",
      cards: [
        {
          id: "rail-maintenance-yards",
          image: "/img/industrial-page/new/transportation/Rail Maintenance Icon 1.png",
          title: "Rail Maintenance Yards",
          subtitle: "Keep locomotives and systems on track.",
          description: 'Use <a href="/products/penetrating-oil-flexible-straw/" target="_blank" rel="noopener noreferrer">WD-40 Specialist® Penetrant</a> to free corroded bolts on undercarriage components. Apply <a href="/products/corrosion-inhibitor/" target="_blank" rel="noopener noreferrer">Corrosion Inhibitor</a> to exposed metal to prevent rust in harsh conditions. Contact Cleaner delivers fast, residue-free cleaning for control panels and signal equipment. Use <a href="/products/spray-gel/" target="_blank" rel="noopener noreferrer">Gel Lube</a> for long-lasting lubrication on trackside parts like rail switches.'
        },
        {
          id: "fleet-service-bays",
          image: "/img/industrial-page/new/transportation/Fleet Maintenance Icon 1.png",
          title: "Fleet Service Bays",
          subtitle: "Cut downtime and protect key systems.",
          description: 'Use <a href="/products/carb-throttle-parts-cleaner/" target="_blank" rel="noopener noreferrer">WD-40 Specialist® Carb/Throttle Body Cleaner</a> to remove oil and grime from engine blocks, brake calipers, and suspension parts. Follow with <a href="/products/white-lithium-grease/" target="_blank" rel="noopener noreferrer">White Lithium Grease</a> to keep tie-downs and ratchets operating seamlessly. <a href="/products/contact-cleaner/" target="_blank" rel="noopener noreferrer">Contact Cleaner</a> restores function to relays, connectors, and wiring harnesses without damaging plastics.'
        },
        {
          id: "roadwork-equipment-yards",
          image: "/img/industrial-page/new/transportation/Roadwork Equipment 1.png",
          title: "Roadwork Equipment Yards",
          subtitle: "Protect machines built for the grind.",
          description: 'Use <a href="/products/dry-lube/" target="_blank" rel="noopener noreferrer">WD-40 Specialist® Dry Lube</a> on chains and conveyors to reduce wear and resist dust buildup. Apply <a href="/products/white-lithium-grease/" target="_blank" rel="noopener noreferrer">White Lithium Grease</a> to loader arms and pivot points to prevent seizing under heavy loads. Clean sensors and control boxes with <a href="/products/contact-cleaner/" target="_blank" rel="noopener noreferrer">Contact Cleaner</a> to ensure consistent performance in dusty environments.'
        }
      ]
    },

    {
      component: "fullWidthCTA",
      id: "facility-map",
      title: "solutions to every area of your facility",
      buttons: [
        {
          text: "download facility map",
          url: "https://www.datocms-assets.com/10845/1725637043-facility-full-of-uses.pdf",
          isSecondary: false
        }
      ]
    },


    {
      component: "cardDeck",
      variant: "badges",
      id: "badges-card-deck",
      title: "Introducing<br>the WD-40 Brand<br>Job Done Right® System",
      subtitle: "Experience a comprehensive solution designed to protect your equipment at every stage.",
      body: "This end-to-end approach ensures optimal performance, reduces the risk of failures, and keeps your machinery running smoothly.",
      extraImages: [
        "/img/industrial-page/new/WD40 - PCLP Graphic_v3 1.png",
        "/img/industrial-page/new/WD-40 Specialist Line 2.png"
      ],
      cards: [
        {
          id: "prep-it",
          image: "/img/industrial-page/new/Industrial Solutions - Prep It - Image.png",
          title: "Prep It",
          description: "Start every job with thorough preparation"
        },
        {
          id: "clean-it",
          image: "/img/industrial-page/new/Industrial Solutions - Clean It - Image.png",
          title: "Clean It",
          description: "Clean your surface for optimal lubrication"
        },
        {
          id: "lube-it",
          image: "/img/industrial-page/new/Industrial Solutions - Lube It - Image.png",
          title: "Lube It",
          description: "Experience superior performance with the best lubrication products on the market"
        },
        {
          id: "protect-it",
          image: "/img/industrial-page/new/Industrial Solutions - Protect It - Image.png",
          title: "Protect It",
          description: "Safeguard your hard work with the trusted protection of the WD-40 Brand"
        }
      ]
    },

    {
      component: "cardDeck",
      variant: "products"
    },

    {
      component: "fullWidthCTA",
      id: "safety-efficiency",
      title: "SOLUTIONS TO MAXIMIZE SAFETY & EFFICIENCY",
      buttons: [
        {
          text: "SAFETY DATA SHEETS",
          url: "https://wd40company.com/partners-suppliers/safety-data-sheets/?region=USA",
          isSecondary: true
        },
        {
          text: "REQUEST SAMPLES",
          url: "/industrial/samplesrequest/",
          isSecondary: false
        }
      ]
    },
    {
      component: "NumberedStepsList",
      id: "trial-program",
      eyebrow: "PREP IT. CLEAN IT. LUBE IT. PROTECT IT.",
      title: "WD-40 BRAND JOB DONE RIGHT TRIAL PROGRAM",
      subtitle: "GET INDUSTRIAL-STRENGTH PERFORMANCE, PROVEN IN YOUR FACILITY.",
      body: "The WD-40 Specialist product line is built to handle the toughest maintenance challenges across industries. Now, with our Job Done Right Trial Program, you can put our solutions to the test—right on your floor, with your team, and your toughest jobs.",
      steps: [
        {
          number: "1",
          title: "ON-SITE ASSESSMENT",
          description: "Our experts visit your facility to understand your systems, challenges, and performance goals. From conveyor lines to electrical panels, we evaluate where you need support most."
        },
        {
          number: "2",
          title: "TAILORED RECOMMENDATIONS BY PRODUCT CATEGORY",
          description: "We match WD-40 Specialist solutions to your specific needs:",
          bulletPoints: [
            {
              title: "Cleaners & Degreasers",
              description: "Remove grease, grime, and contaminants fast"
            },
            {
              title: "Lubricants & Penetrants",
              description: "Free stuck parts and reduce friction"
            },
            {
              title: "Rust Solutions",
              description: "Stop rust and protect metal surfaces"
            }
          ]
        },
        {
          number: "3",
          title: "TRIAL IMPLEMENTATION",
          description: "We'll run a live trial in your environment to demonstrate product performance where it matters most—on the job. You'll receive a detailed Findings Report with key metrics, ROI, and measurable improvements."
        },
        {
          number: "4",
          title: "LONG-TERM OPTIMIZATION",
          description: "The trial is just the beginning. Our team supports your ongoing success with training, product guidance, and evolving solutions as your facility grows."
        }
      ]
    },
    {
      component: "site-assessment-form"
    },
    {
      component: "cardDeck",
      variant: 'faqs',
      id: "food-beverage-faqs",
      title: "FREQUENTLY ASKED QUESTIONS",
      cards: [
        {
          id: "faq-1",
          title: "Does WD-40® Brand offer solutions built for transportation maintenance?",
          body: "Yes. WD-40 Brand offers a full line of maintenance products designed to perform in transportation environments—from fleet garages to rail yards. Our WD-40 Specialist® line helps you tackle corrosion, lubrication, and electrical issues with fewer SKUs and more confidence."
        },
        {
          id: "faq-2",
          title: "How do WD-40® Brand products support uptime in transit and fleet operations?",
          body: "We focus on the 80/20 rule—solving the most common maintenance challenges with targeted, high-performance formulas. From freeing stuck parts to cleaning sensitive electronics, our solutions help reduce breakdowns, speed up repairs, and keep your operation moving."
        },
        {
          id: "faq-3",
          title: "Are WD-40® Brand products compliant and safe to use on mixed-material systems?",
          body: "Absolutely. WD-40 Brand products are 50-state VOC compliant and require no California Prop 65 warning. WD-40 Brand products are formulated for use on many materials commonly found in the transportation industry—such as metals, rubbers, and plastics. As with any product, we recommend testing on a small, inconspicuous area or consulting equipment specifications before full application."
        }
      ],
      ctaText: "ASK A TECHNICAL SPECIALIST",
      ctaUrl: "/industrial/technicalspecialist/"
    }
  ],

};
